import {
  WSCard,
  WSControl,
  WSInfoBox,
  WSList
} from "@wingspanhq/fe-component-library";
import { useState } from "react";

type Props = {
  payerName: string;
  onContinueClick: () => void;
};

export const CardShareYourInformation: React.FC<Props> = props => {
  const [checked, setChecked] = useState(false);

  return (
    <WSCard
      header={{
        label: {
          text: "Share your information"
        }
      }}
      actions={{
        alignment: "fill",
        buttons: [
          {
            label: "Continue",
            onClick: props.onContinueClick,
            disabled: !checked
          }
        ]
      }}
    >
      <WSList gap="XL">
        <WSInfoBox>
          Grant access to your resources so we can check your insurance policies
          and documents to determine if they meet the eligibility requirements
          set by your client, {props.payerName}. You only have to grant access
          once per client to perform matching for future requirements from that
          client. Here’s what to expect
        </WSInfoBox>

        <WSInfoBox transparent>
          <ol>
            <li>
              <b>Policy match</b>
              <ul>
                <li>
                  Consent to share your information with the client to enable
                  the matching process.
                </li>
                <li>
                  The app will check your resources for any insurance policies
                  from your “My resources” section under settings.{" "}
                  <a>Learn more</a>
                </li>
                <li>Matched policies will advance you to the last step.</li>
                <li>
                  Follow instructions when no matches or mismatches occur.
                </li>
              </ul>
              <br />
            </li>
            <li>
              <b>Client approval and completion</b>
              <ul>
                <li>
                  Insurance policies that match and pass will complete the
                  requirement automatically, unless a manual review is required
                  by the client — in which case the requirement will be complete
                  only after client approval.
                </li>
              </ul>
            </li>
          </ol>
        </WSInfoBox>

        <WSControl
          size="S"
          type="checkbox"
          label="I authorize Wingspan to share my resources (including insurance policies, documents, and tax information) that I’ve added to my account. I understand this information will be used for compliance and eligibility purposes in accordance with applicable laws and regulations."
          value={checked}
          onChange={setChecked}
        />
      </WSList>
    </WSCard>
  );
};
